import { createFileRoute } from '@tanstack/react-router';
import { RoleGuard } from '@/lib/auth/RoleGuard';
import { AuthenticatedShell } from '@/features/app/AuthenticatedShell';
import { ThresholdSettings } from '@/features/admin/readiness/ThresholdSettings';
import { CriteriaConfig } from '@/features/admin/readiness/CriteriaConfig';

export const Route = createFileRoute('/admin/readiness')({ component: ReadinessAdminPage });

function ReadinessAdminPage() {
  return (
    <RoleGuard allow={['PlatformAdmin']}>
      <AuthenticatedShell activeNavId="admin-readiness">
        <div className="mx-auto max-w-4xl space-y-6 p-6">
          <header>
            <h1 className="text-xl font-semibold text-slate-900">Readiness configuration</h1>
            <p className="text-sm text-slate-500">
              Platform-wide. Every change advances the configuration version; existing badges keep
              their version until recomputed.
            </p>
          </header>
          <section className="rounded-lg border border-slate-200 bg-white p-4">
            <h2 className="mb-3 text-sm font-semibold text-slate-700">Badge thresholds</h2>
            <ThresholdSettings />
          </section>
          <section className="rounded-lg border border-slate-200 bg-white p-4">
            <h2 className="mb-3 text-sm font-semibold text-slate-700">Criteria</h2>
            <CriteriaConfig />
          </section>
        </div>
      </AuthenticatedShell>
    </RoleGuard>
  );
}
